export const typography = {
  fontSize: 14,
  htmlFontSize: 10,
  h1: {
    fontSize: 24,
    fontWeight: 400,
  },
  h2: {
    fontSize: 18,
    fontWeight: 500,
  },
  subtitle1: {
    fontSize: 18,
    fontWeight: 600,
  },
  subtitle2: {
    fontSize: 18,
    fontWeight: 400,
  },
  subtitle3: {
    fontSize: 12,
    fontWeight: 400,
  },
  body1: {
    fontSize: 14,
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    fontWeight: 500,
  },
  small: {
    fontSize: 10,
    fontWeight: 400,
  },
};
